export const TimeZoneMapping: {[key: string]: string} = {
  "CST": "America/Chicago",
  "AKST": "America/Anchorage",
  "MST": "America/Denver",
  "HST": "Pacific/Honolulu",
  "EDT": "America/New_York",
  "PST": "America/Los_Angeles"
}

export interface DateStrings {
  formattedDate: string
  gmtFullDate: string
  gmtShortDate: string
}

export default function CalculateDateStrings(date: Date, timezoneCode: string | undefined): DateStrings {
  const result: DateStrings = {
    formattedDate: "",
    gmtFullDate: "",
    gmtShortDate: ""
  }
  const timezone = timezoneCode ? TimeZoneMapping[timezoneCode] : undefined

  const timezoneDateString = date.toLocaleString("en-US", { timeZone: timezone })
  const timezoneDate = new Date(timezoneDateString)

  const diff = Math.round((timezoneDate.getTime() - date.getTime()) / (1000 * 60 * 60)) // in hours
  const localOffset = Math.round(new Date(date).getTimezoneOffset() / 60) // local offset in hours
  const offset = diff - localOffset //time zone offset in hours

  const sign = Math.sign(offset) === -1 ? "-" : "+";

  const dt = new Date(timezoneDate.getTime() - localOffset * 60 * 60 * 1000)
  result.formattedDate = `${dt.toISOString().replace("Z", "")}${sign}${Math.abs(offset).toString().padStart(2, "0")}:00`

  const userDate = timezoneDate.toLocaleString("en-US", { month: "long", day: "numeric", year: 'numeric', hour: "numeric", minute: "numeric" })
  result.gmtFullDate = `${userDate} GMT${sign}${Math.abs(offset)}`

  const shortDate = timezoneDate.toLocaleString("en-US" , { month: "2-digit", day: "2-digit", year: '2-digit', hour: "numeric", minute: "2-digit" }).replace(",", "")
  result.gmtShortDate = `${shortDate} GMT${sign}${Math.abs(offset)}`

  return result
}
